'use client';

import { useLayoutStore } from '@/hooks/use-layout-store';
import { PropsWithChildren, useEffect, useRef } from 'react';

/**Loader when change version */
export function CustomVersionLoader({ children }: PropsWithChildren) {
    const progress = useLayoutStore((state) => state.progress);
    const setProgress = useLayoutStore((state) => state.setProgress);

    const interval = useRef<NodeJS.Timeout>();

    useEffect(() => {
        if (progress > -1) {
            interval.current = setInterval(() => {
                setProgress((prevProgress) => {
                    if (prevProgress >= 100) {
                        clearInterval(interval.current);
                        return -1;
                    }
                    return prevProgress + Math.random() * 20;
                });
            }, 20);
        }
        return () => {
            clearInterval(interval.current);
        };
    }, [progress, setProgress]);

    // if (progress !== -1) return <ProgressBar key={state} progress={progress} />;

    return progress === -1 ? children : <></>;
}
